exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app{font-family:\"Segoe UI\", \"Open Sans\", \"Rubik\", \"Avenir\", Helvetica, Arial, sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50\n}\n", "", {"version":3,"sources":["C:/ProgramData/Jenkins/.jenkins/workspace/ICode_Dev_Client_HOME/src/C:/ProgramData/Jenkins/.jenkins/workspace/ICode_Dev_Client_HOME/src/App.vue"],"names":[],"mappings":";AAuBA,KACE,qFACA,mCACA,kCACA,aAAc;CACf","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n#app {\n  font-family: \"Segoe UI\", \"Open Sans\", \"Rubik\", \"Avenir\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = OCj8
// module chunks = 1